<template>
    <b-row>
        <b-col md="12">
            <gofix-card fullContent class="mb-0">
                <gofix-table
                    class="hoverUnderLineLink noFullHeight"
                    :settings="tableConfig"
                    :table-items="tableItems"
                    @load-items="getTableData"
                    @row-click="goToDetail"
                    ref="gofixTable">
                    <template slot="gofix_table:job_number" slot-scope="row">
                        <u>{{row.item.job_number}}</u>
                    </template>
                    <template slot="gofix_table:planned_date" slot-scope="row">
                        {{row.item.planned_date  | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY")}}
                    </template>
                </gofix-table>
            </gofix-card>
        </b-col>
    </b-row>
</template>

<script>
    import { mapGetters } from 'vuex';
    export default {
        name: 'permit-to-work-detail-related-items',
        components: {
        },
        data() {
            return{
                tableConfig:{
                    name: 'permit_to_work_items',
                    controls:{
                        reload: false,
                        create: false,
                        delete: false,
                        tableFilter:false,
                        tableImport:false,
                        tableExport:false,
                        tableColumnSettings:false,
                        tablePagination:false,
                    },
                    filter: {},
                    page: 1,
                    limit: 100,
                    total: 0,
                    useDatabaseView: true,
                    sortColumn: "id",
                    sortDirection: "asc",
                    fields: [
                        {
                            key: 'job_number',
                            label: 'PTW Number',
                            thStyle: "width:300px",
                            width: 200,
                            isActive: 1,
                            isFilter: false,
                            sorting: false
                        },
                        {
                            key: 'planned_date',
                            label: 'Date',
                            thStyle: "width:200px",
                            width: 200,
                            isActive: 1,
                            isFilter: false,
                            sorting: false
                        },
                        {
                            key: 'status',
                            label: 'Status',
                            thStyle: "width:auto",
                            width: null,
                            isActive: 1,
                            isFilter: false,
                            sorting: false
                        },
                    ]
                },
                tableItems:[],
            }
        },
        computed: {
            ...mapGetters({
                Item: 'SafetyAppController/safetyJob',
                JobWorkFinding: "SafetyAppController/workFindings",
                Loading: "SafetyAppController/wfLoading",
            }),
            WorkFindings: function() {
                return this.JobWorkFinding.items;
            },
            isAccess() {
                if(this.Item && this.Item.status != 'New') return false;
                return true;
            },
        },
        created() {
        },
        methods: {
            /*---------- Table event ----------*/
            async getTableData(callback){
                const { resolve } = await callback();
                let result = { items:[], total:0 };
                this.tableItems = [];
                this.tableConfig.total = 0;
                if(this.Item && this.Item.related && this.Item.related.length) {
                    this.tableItems = result.items = this.Item.related;
                    this.tableConfig.total = result.total = this.Item.related.length;
                }
                resolve(result);
            },
            goToDetail(item){
                let routeData = this.$router.resolve(`/v2/permit-to-work/${item.id}`)
                window.open(routeData.href, '_blank');
            }
        }
    }
</script>
